class DevicePostureCheckLogsDatatable {
    constructor(element, deviceID = null){
        let searchParams = new URLSearchParams(window.location.search);
        this.start = searchParams.get('start');
        this.end = searchParams.get('end');
        this.organizationID = searchParams.get('organizationID');
        this.subtableTemplate = null;
        this.subtableHeaderTemplate = null;
        this.datatable = this.init(element, this.organizationID, deviceID);
        this.filterActions();
    }
    init(el, organizationID, deviceID){
        const thisClass = this;
        // Get subtable template
        let subtable = document.querySelector(el+' tr[data-kt-docs-datatable-subtable="subtable_template"]');
        let subtableHeader = document.querySelector(el+' tr[data-kt-docs-datatable-subtable="subtable_header_template"]');
        if(subtable && subtableHeader){
            this.subtableTemplate = subtable.cloneNode(true);
            this.subtableHeaderTemplate = subtableHeader.cloneNode(true);
            this.subtableTemplate.classList.remove('d-none');
            this.subtableHeaderTemplate.classList.remove('d-none');
            // Remove subtable template
            subtable.parentNode.removeChild(subtable);
        }

        const datatable =  $(el).DataTable({
            searchDelay: 400,
            scrollCollapse: true,
            processing: true,
            serverSide: true,
            stateSave: false,
            info: true,
            paging: true,
            order: [[5, 'desc']],
            searchCols: [
                null,
                null,
                null,
                null,
                null,
                { "search": (this.start && this.end ? this.start+' - '+this.end : moment().startOf('isoWeek').format("YYYY-MM-DD hh:mm:ss")+' - '+moment().endOf('isoWeek').format("YYYY-MM-DD hh:mm:ss")), "regex": false }
            ],
            ajax: {
                url: '/device-posture-check-logs/?do=getDevicePostureCheckLogs',
                type: 'POST',
                data: {
                    organizationID: organizationID,
                    deviceID: deviceID
                }
            },
            language: {
                emptyTable: "No data found"
            },
            dom:
                "<'table-responsive'tr>" +
                "<'row'" +
                "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start'li>" +
                "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end'p>" +
                ">",
            drawCallback: function(settings) {
                // Remove all visible popovers after datatable draw
                document.querySelectorAll('.popover.fade.show').forEach(function (el) {
                    el.remove();
                });
                // Init all popovers after datatable draw
                const popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
                popoverTriggerList.map(function (popoverTriggerEl) {
                    new bootstrap.Popover(popoverTriggerEl);
                });
                // init page length select
                $('select[name='+el.substring(1)+'_length]').select2({minimumResultsForSearch: -1});
            },
            columns: [
                {
                    sortable: false,
                    data: 'expand',
                    render: function (data, type, row) {
                        return '<button type="button" class="btn btn-sm btn-icon btn-light btn-active-light-primary toggle h-20px w-20px ' +
                            (!row['detail'] || row['detail'].length === 0 ? 'd-none' : '')+'" data-kt-docs-datatable-subtable="expand_row">\n' +
                            '<i class="ki-duotone ki-plus fs-3 m-0 toggle-off"></i><i class="ki-duotone ki-minus fs-3 m-0 toggle-on"></i></button>';
                    }
                },
                {
                    data: 'deviceUuid',
                    title: 'Device',
                    sortable: true,
                    className: 'min-w-250px',
                    render: function (data, type, row) {
                        return '<div class="d-flex align-items-center">' +
                            '       <div class="symbol symbol-40px me-3 border ga-border-primary-300 symbol-circle">' +
                            '           <div class="symbol-label bg-light-primary border border-2 border-white overflow-hidden'+(row['deviceInfo']['isBlocked'] ? ' filter-grayscale' : '')+'">' +
                            '               <img src="/media/goodaccess/icons/os/' + row['deviceInfo']['osName'] + '.svg" alt="avatar" class="h-40px">' +
                            '           </div>' +
                            (row['deviceInfo']['isBlocked'] ? '<span class="symbol-badge badge badge-circle bg-danger start-85 top-85 w-15px h-15px fs-10 text-center text-white" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="<div class=\'fw-bold\'>blocked</div>">&#10005;</span>' : '') +
                            '       </div>' +
                            '       <div class="d-flex justify-content-start flex-column">' +
                            '           <div>' +
                            '<span class="fw-bold text-decoration-underline-ga primary text-primary mb-1 fs-6" '+(row['deviceInfo']['edit'] ? 'id="'+row['deviceInfo']['uuid']+'"' : '')+'>' +
                            (row['deviceInfo']['edit'] ? '<span class="edit-device">' : '')
                            +row['deviceInfo']['name']+'' +
                            (row['deviceInfo']['edit'] ? '</span>' : '')+
                            '               </span>' +
                            '           </div>' +
                            '           <span class="fw-semibold d-block fs-7 ga-text-primary-800">' + row['deviceInfo']['osNameWithVersion'] +'</span>' +
                            '        </div>' +
                            '   </div>';
                    }
                },
                {
                    data: 'status',
                    title: 'Result',
                    render: function (data, type, row) {
                        if(!row['detail']){
                            return '';
                        }

                        if(!row['isSuccessful']){
                            let numberOfFails = 0;
                            for(let i = 0; i < row['detail'].length; i++){
                                if(!row['detail'][i]['isSuccessful']){
                                    numberOfFails += 1;
                                }
                            }
                            return '<span class="badge badge-light-danger border border-danger">' +
                                '    <i class="fa-solid fa-xmark text-danger me-1"></i> Failed <span class="ms-1">'+numberOfFails+'/'+row['detail'].length+'</span>' +
                                '   </span>';
                        }

                        return '<span class="badge badge-light-success border border-success">' +
                            '    <i class="fa-solid fa-check text-success me-1"></i> Passed <span class="ms-1">'+row['detail'].length+'/'+row['detail'].length+'</span>' +
                            '   </span>';
                    }
                },
                {
                    data: 'memberUuid',
                    title: 'Member',
                    sortable: true,
                    className: 'min-w-120px',
                    render: function (data, type, row) {
                        return new MemberInfoGenerator(row['vpnUserInfo']).generateTableMember();
                    }
                },
                {
                    data: 'timestamp',
                    title: 'First checked',
                    className: 'min-w-90px',
                    sortable: true,
                    render: function (data, type, row) {
                        return `<span data-bs-toggle="popover" data-bs-trigger="hover" data-bs-placement="bottom" data-bs-content="${row['timezone']}">${row['timestamp']}</span>`;
                    }
                },{
                    data: 'lastCheck',
                    title: 'Last checked',
                    className: 'min-w-90px',
                    sortable: true,
                    render: function (data, type, row) {
                        return `<span data-bs-toggle="popover" data-bs-trigger="hover" data-bs-placement="bottom" data-bs-content="${row['timezone']}">${row['lastCheck']}</span>`;
                    }
                }
            ]
        }).on('draw', function () {
            thisClass.resetSubtable(el);
            thisClass.handleActionButton(el);
            if(datatable.page.info().recordsTotal === 0){
                $(el+'_wrapper').hide();
                $(el+'_no-results').addClass('d-flex flex-center flex-column').removeClass('d-none');
            } else {
                $(el+'_wrapper').show();
                $(el+'_no-results').addClass('d-none').removeClass('d-flex flex-center flex-column');
            }
        });
        // Init and add delay to datatable search
        new DatatableSearchDelay(datatable, '[data-kt-docs-table-filter=device-posture-check-log-search]');
        return datatable;
    }
    handleActionButton(el){
        const buttons = document.querySelectorAll('[data-kt-docs-datatable-subtable="expand_row"]');

        buttons.forEach((button, index) => {
            button.addEventListener('click', e => {
                e.stopImmediatePropagation();
                e.preventDefault();

                const row = button.closest('tr');
                const rowClasses = ['isOpen', 'border-bottom-0'];

                // Handle subtable expanded state
                if (row.classList.contains('isOpen')) {
                    // Remove all subtables from current order row
                    while (row.nextSibling && (row.nextSibling.getAttribute('data-kt-docs-datatable-subtable') === 'subtable_template' || row.nextSibling.getAttribute('data-kt-docs-datatable-subtable') === 'subtable_header_template')) {
                        row.nextSibling.parentNode.removeChild(row.nextSibling);
                    }
                    row.classList.remove(...rowClasses);
                    button.classList.remove('active');
                } else {
                    this.populateTemplate(this.datatable.row(row).data().detail, row, el);
                    row.classList.add(...rowClasses);
                    button.classList.add('active');
                }

                // Remove all visible popovers after datatable draw
                document.querySelectorAll('.popover.fade.show').forEach(function (el) {
                    el.remove();
                });
                // Init all popovers after datatable draw
                const popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
                popoverTriggerList.map(function (popoverTriggerEl) {
                    new bootstrap.Popover(popoverTriggerEl);
                });
            });
        });
    }
    // Populate template with content/data -- content/data can be replaced with relevant data from database or API
    populateTemplate(data, target, el){
        const thisClass = this;

        // create reason list
        data.forEach((d, index) => {
            // Clone template node
            const newTemplate = this.subtableTemplate.cloneNode(true);
            newTemplate.classList.remove('d-none');

            const status = newTemplate.querySelector('[data-kt-docs-datatable-subtable="status"]');
            status.innerHTML = d.isSuccessful ? '<i class="fa-solid fa-check text-success me-1"></i> Passed' : '<i class="fa-solid fa-xmark text-danger me-1"></i> Failed';
            if(d.isSuccessful){
                status.classList.add('badge-light-success', 'border', 'border-success');
            } else {
                status.classList.add('badge-light-danger', 'border', 'border-danger');
            }
            const reasons = newTemplate.querySelector('[data-kt-docs-datatable-subtable="reasons"]');
            let reasonsText = '';
            d.reasons.forEach((reason, index) => {
                reasonsText += reason+', ';
                // reasons.appendChild(createNewListItem(reason));
            });
            reasons.innerText = reasonsText.substring(0, reasonsText.length - 2);

            const dpcName = newTemplate.querySelector('[data-kt-docs-datatable-subtable="dpc_name"]');
            dpcName.innerText = d.devicePostureCheckInfo.name;

            const dpcDefaultIcon = newTemplate.querySelector('[data-kt-docs-datatable-subtable="dpc_default_icon"]');
            const dpcIcon = newTemplate.querySelector('[data-kt-docs-datatable-subtable="dpc_icon"]');
            if(!d.devicePostureCheckInfo.isDefault){
                dpcIcon.innerText = d.devicePostureCheckInfo.name.substring(0,1);
                dpcDefaultIcon.remove();
            }

            if(!d.devicePostureCheckInfo.isDeleted){
                const dpcDescription = newTemplate.querySelector('[data-kt-docs-datatable-subtable="dpc_decription"]');
                if(d.devicePostureCheckInfo.shortDescription){
                    if(d.devicePostureCheckInfo.shortDescription !== d.devicePostureCheckInfo.description){
                        dpcDescription.setAttribute('data-bs-toggle', 'popover');
                        dpcDescription.setAttribute('data-bs-placement', 'top');
                        dpcDescription.setAttribute('data-bs-trigger', 'hover');
                        dpcDescription.setAttribute('data-bs-content', d.devicePostureCheckInfo.description);
                    }
                    dpcDescription.innerText = d.devicePostureCheckInfo.shortDescription;
                }
                if(d.devicePostureCheckInfo.edit){
                    dpcName.parentElement.id = d.devicePostureCheckInfo.uuid;
                    dpcName.classList.add('text-decoration-underline-ga', 'primary', 'edit-device-posture-check');
                }
            } else {
                dpcName.classList.add('text-muted');
                dpcIcon.classList.add('text-muted', 'bg-secondary');
                dpcIcon.classList.remove('bg-light-primary');
                dpcName.innerHTML += '<i class="fa-regular fa-circle-question cursor-help ms-2" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="<div class=\'text-center\'>This Device Posture Check has been deleted.</div>"><span class="path1"></span><span class="path2"></span><span class="path3"></span></i>';
            }

            // New template border controller
            if (data.length === 1) {
                if (index === 0) { // last row
                    let borderClasses = ['rounded-start', 'rounded-top-0'];
                    newTemplate.querySelectorAll('td')[0].classList.add(...borderClasses);
                    borderClasses = ['rounded-end', 'rounded-top-0'];
                    newTemplate.querySelectorAll('td')[3].classList.add(...borderClasses);
                }
            }

            // Insert new template into table
            const tbody = document.querySelector(el).querySelector('tbody');
            tbody.insertBefore(newTemplate, target.nextSibling);
        });

        const newHeaderTemplate = this.subtableHeaderTemplate.cloneNode(true);
        newHeaderTemplate.classList.remove('d-none');
        // Insert new template into table
        const tbody = document.querySelector(el).querySelector('tbody');
        tbody.insertBefore(newHeaderTemplate, target.nextSibling);
    }
    // Reset subtable
    resetSubtable(el){
        const subtables = document.querySelectorAll('[data-kt-docs-datatable-subtable="subtable_template"]');
        subtables.forEach(st => {
            st.parentNode.removeChild(st);
        });

        const rows = document.querySelector(el).querySelectorAll('tbody tr');
        rows.forEach(r => {
            r.classList.remove('isOpen');
            if (r.querySelector('[data-kt-docs-datatable-subtable="expand_row"]')) {
                r.querySelector('[data-kt-docs-datatable-subtable="expand_row"]').classList.remove('active');
            }
        });
    }
    filterActions(){
        this.initSelect2();
        this.initDateTimePicker();
        this.resetFilters();

        const thisClass = this;
        const filterButton = document.querySelector('[data-kt-docs-table-filter="device-posture-check-log-filter"]');
        if(filterButton){
            filterButton.addEventListener('click', function () {
                thisClass.applyFilter();
            });
        }
    }
    initSelect2(){
        const optionStatusFormat = function (item) {
            if (!item.id) {
                return item.text;
            }

            const value = item.element.value;
            let span = document.createElement('span');
            if (value === '1') {
                span.classList.add('badge', 'badge-lg', 'badge-light-success', 'position-relative', 'px-4', 'border', 'border-success');
                span.innerText = 'Passed';
            } else {
                span.classList.add('badge', 'badge-lg', 'badge-light-danger', 'position-relative', 'px-4', 'border', 'border-danger');
                span.innerText = 'Failed';
            }

            return $(span);
        };
        // Format Member options
        const tagFormat = (item) => {
            if (!item.id) {
                return item.text;
            }
            const span = document.createElement('span');
            span.innerHTML = item.text;
            return $(span);
        }
        // Format Member results
        const optionFormat = (item) => {
            if (!item.id) {
                return item.text;
            }
            const span = document.createElement('span');
            let template = '';
            template += '<div class="d-flex align-items-center">';
            template += item.element.getAttribute('data-kt-rich-content-avatar');
            template += '<div class="d-flex flex-column">'
            template += '<span class="fs-6 fw-bold lh-1 text-primary">' + item.text + item.element.getAttribute('data-kt-rich-content-badges') + '</span>';
            template += '<span class="fw-semibold ga-text-primary-800 fs-8">' + item.element.getAttribute('data-kt-rich-content-subcontent') + '</span>';
            template += '</div>';
            template += '</div>';
            span.innerHTML = template;
            return $(span);
        }

        // Init Select2
        $('[data-kt-docs-table-filter=device-posture-check-log-members]').select2({
            placeholder: "Select an option",
            templateSelection: tagFormat,
            templateResult: optionFormat,
        });
        $('[data-kt-docs-table-filter=device-posture-check-log-devices]').select2({
            placeholder: "Select an option",
            templateSelection: tagFormat,
            templateResult: optionFormat,
        });
        $('[data-kt-docs-table-filter=device-posture-check-log-policy]').select2({
            placeholder: "Select an option",
            templateSelection: tagFormat,
            templateResult: optionFormat,
        });
        $('[data-kt-docs-table-filter=device-posture-check-log-status]').select2({
            laceholder: "Select an option",
            templateSelection: optionStatusFormat,
            templateResult: optionStatusFormat,
            minimumResultsForSearch: -1
        });
    }
    initDateTimePicker(){
        const dateEl = $("[data-kt-docs-table-filter=device-posture-check-log-date]");
        let start = moment().startOf('isoWeek');
        let end = moment().endOf('isoWeek');

        function formatDate(start, end) {
            dateEl.html(start.format("MMM D, YYYY") + " - " + end.format("MMM D, YYYY"));
        }

        dateEl.daterangepicker({
            startDate: start,
            endDate: end,
            locale: {
                format: "MMM D, YYYY"
            },
            ranges: {
                "Today": [moment(), moment()],
                "Yesterday": [moment().subtract(1, "days"), moment().subtract(1, "days")],
                "This Week": [moment().startOf('isoWeek'), moment().endOf('isoWeek')],
                "Last Week": [moment().startOf('isoWeek').subtract(7, "days"), moment().endOf('isoWeek').subtract(7, "days")],
                "This Month": [moment().startOf("month"), moment().endOf("month")],
                "Last Month": [moment().subtract(1, "month").startOf("month"), moment().subtract(1, "month").endOf("month")]
            }
        }, formatDate);
        formatDate(start, end);
    }
    resetFilters(){
        const thisClass = this;

        // Select reset button
        const resetButton = document.querySelector('[data-kt-docs-table-filter="device-posture-check-log-reset"]');
        if(resetButton){
            // Reset datatable
            resetButton.addEventListener('click', function () {
                // Reset members and domains
                $('[data-kt-docs-table-filter=device-posture-check-log-members]').val([]).trigger('change');
                $('[data-kt-docs-table-filter=device-posture-check-log-devices]').val([]).trigger('change');
                $('[data-kt-docs-table-filter=device-posture-check-log-policy]').val([]).trigger('change');
                $('[data-kt-docs-table-filter=device-posture-check-log-status]').val(null).trigger('change');
                // Reset Date filter
                const dateEl = $("[data-kt-docs-table-filter=device-posture-check-log-date]");
                dateEl.data('daterangepicker').setStartDate(moment().startOf('isoWeek'));
                dateEl.data('daterangepicker').setEndDate(moment().endOf('isoWeek'));

                thisClass.applyFilter(true);
            });
        }
    }
    applyFilter(reset = false){
        let numberOfActiveFilters = 1; // Date is always set

        if(reset){
            this.datatable.columns().search('');
        } else {
            // Select filter options
            let date = document.querySelector('[data-kt-docs-table-filter="device-posture-check-log-date"]');

            let members = $('[data-kt-docs-table-filter="device-posture-check-log-members"]').select2('data');
            let membersArr = [];
            for(const i in members){
                if(members[i].id !== ''){
                    membersArr.push(members[i].id);
                }
            }

            let devices = $('[data-kt-docs-table-filter="device-posture-check-log-devices"]').select2('data');
            let devicesArr = [];
            for(const i in devices){
                if(devices[i].id !== '') {
                    devicesArr.push(devices[i].id);
                }
            }

            let devicePostureCheck = $('[data-kt-docs-table-filter="device-posture-check-log-policy"]').select2('data');
            let devicePostureCheckArr = [];
            for(const i in devicePostureCheck){
                if(devicePostureCheck[i].id !== '') {
                    devicePostureCheckArr.push(devicePostureCheck[i].id);
                }
            }

            this.datatable.column(1).search(JSON.stringify(devicesArr));
            numberOfActiveFilters += devicesArr.length;
            this.datatable.column(4).search(JSON.stringify(devicePostureCheckArr));
            numberOfActiveFilters += devicePostureCheckArr.length;
            this.datatable.column(3).search(JSON.stringify(membersArr));
            numberOfActiveFilters += membersArr.length;
            this.datatable.column(5).search(date.value);

            let status = document.querySelector('[data-kt-docs-table-filter="device-posture-check-log-status"]').value;
            this.datatable.column(2).search(status);
            numberOfActiveFilters += status === '0' || status === '1' ? 1 : 0;
        }

        this.datatable.draw();

        $('#devicePostureCheckLogsNumberOfFilters').text(numberOfActiveFilters);
    }
}
window.DevicePostureCheckLogsDatatable = DevicePostureCheckLogsDatatable;